import baseApi from "src/config/api/base"
import { ApplyRequest, ApplyResponse, ResendOtpRequest, ResendOtpResponse } from "./types/apply"
import { Apply2Request, Apply2Response } from "./types/apply2"
import { Apply3Request, Apply3Response } from "./types/apply3"
import { BaseRequest, BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { PosGetGiroScaleDetailRequest, PosGetGiroScaleDetailResponse } from "./types/posGetGiroScaleDetail"
import { Apply4Request, Apply4Response } from "./types/apply4"
import { Apply5Request, Apply5Response } from "./types/apply5"
import { PosOkcMarkaListResponse } from "./types/posOkcMarkaList"
import { OkcMaliIdRequest, OkcMaliIdResponse } from "./types/okcMaliId"
import { OkcModelListRequest, OkcModelListResponse } from "./types/okcModelList"
import { Apply6Request, Apply6Response } from "./types/apply6"
import { GetCountryListRequest, GetCountryListResponse } from "./types/country"
import { GetIslemHacimleriResponse, GetIslemSayisiResponse, GetVarlikKaynagiResponse, WorkTypeRequest, WorkTypeResponse } from "./types/job"
import { Apply7Request, Apply7Response } from "./types/apply7"
import { GetWorkPlaceNameByNameRequest, GetWorkPlaceNameByNameResponse } from "./types/getWorkPlaceNameByName"
import { GetCitiesResponse, GetDistrictsRequest, GetDistrictsResponse, GetTownsRequest, GetTownsResponse } from "./types/adress"
import { Apply8Request, Apply8Response } from "./types/apply8"
import { Apply9Request } from "./types/apply9"
import { GetConfigListRequest, GetConfigListResponse } from "./types/configList"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: "MERC001",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfigList: builder.mutation<GetConfigListResponse, GetConfigListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          functionCode: "MERC001",
          cid: body.cid,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/RefreshCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          cepTel: body.cepTel,
          dogumYil: body.dogumYil,
          dogumAy: body.dogumAy,
          dogumGun: body.dogumGun,
          captcha: body.captcha,
          kvkk: body.kvkk,
          cid: body.cid,
          deviceId: body.deviceId,
          app: body.app,
          mim: body.mim,
          ts: body.ts,
          plainCid: body.plainCid,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/Apply1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/ResendOtp1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          otp: body.otp,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/Apply2",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3: builder.mutation<Apply3Response, Apply3Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          kimlikSeriSiraNo: body.kimlikSeriSiraNo,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/Apply3",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    posGetGiroScaleDetail: builder.mutation<PosGetGiroScaleDetailResponse, PosGetGiroScaleDetailRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          paket: body.paket,
          posTipi: body.posTipi,
          terminalId: body.terminalId,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/PosGetGiroScaleDetail1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply4: builder.mutation<Apply4Response, Apply4Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          posTipi: body.posTipi,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/Apply4",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply5: builder.mutation<Apply5Response, Apply5Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          posPaketTercihi: body.posPaketTercihi,
          isyeriFaaliyetAlani: body.isyeriFaaliyetAlani,
          taksitliSatisTercihi: body.taksitliSatisTercihi,
          posTipiTercihi: body.posTipiTercihi,
          chipParaTercihi: body.chipParaTercihi,
          fastYetki: body.fastYetki,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/Apply5",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    posOkcMarkaList: builder.mutation<PosOkcMarkaListResponse, BaseRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/DPWebPosLookupData/PosOkcMarkaList1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    okcMaliId: builder.mutation<OkcMaliIdResponse, OkcMaliIdRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          okcMarkaId: body.okcMarkaId,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/OkcMaliId1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    okcModelList: builder.mutation<OkcModelListResponse, OkcModelListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          okcMarkaId: body.okcMarkaId,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/DPWebPosLookupData/PosOkcModelList1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply6: builder.mutation<Apply6Response, Apply6Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          okcMaliIdIdx: body.okcMaliIdIdx,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/Apply6",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getSecondNationalyCountryList: builder.mutation<GetCountryListResponse, GetCountryListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/SecondNationalityCountryList1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getWorkTypes: builder.mutation<WorkTypeResponse, WorkTypeRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          meslekIsTuruKodu: body.meslekIsTuruKodu,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/WorkTypeList1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getVarlikKaynagi: builder.mutation<GetVarlikKaynagiResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CddVarlikKaynagiTicariList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getIslemHacimleri: builder.mutation<GetIslemHacimleriResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CddIslemHacmiList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getIslemSayisi: builder.mutation<GetIslemSayisiResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CddIslemSayisiTicariList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply7: builder.mutation<Apply7Response, Apply7Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          yerlesikUlke: body.yerlesikUlke,
          yurtdisiBaglantisi: body.yurtdisiBaglantisi,
          isTuru: body.isTuru,
          meslek: body.meslek,
          onlyJobFields: body.onlyJobFields,
          varlikKaynaklari: body.varlikKaynaklari,
          islemHacmi: body.islemHacmi,
          islemSayisi: body.islemSayisi,
          ciro: body.ciro,
          ciroYili: body.ciroYili,
          cddFields: body.cddFields,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/Apply7",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getWorkPlaceNameByName: builder.mutation<GetWorkPlaceNameByNameResponse, GetWorkPlaceNameByNameRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          name: body.name,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/WorkPlaceName1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCities: builder.mutation<GetCitiesResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CitiesList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getTowns: builder.mutation<GetTownsResponse, GetTownsRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/DistrictsList1",
          ilKodu: body.ilKodu,
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getDistricts: builder.mutation<GetDistrictsResponse, GetDistrictsRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/DigitalProductLookupData/GetMahalleler1",
          ilId: body.ilId,
          ilceId: body.ilceId,
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply8: builder.mutation<Apply8Response, Apply8Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          isyeriAdi: body.isyeriAdi,
          isyeriTelefonu: body.isyeriTelefonu,
          kurulumAdresIl: body.kurulumAdresIl,
          kurulumAdresIlce: body.kurulumAdresIlce,
          kurulumAdresMahalle: body.kurulumAdresMahalle,
          kurulumAdres: body.kurulumAdres,
          kurulumAdresiIletisimAdresi: body.kurulumAdresiIletisimAdresi,
          iletisimAdresTipi: body.iletisimAdresTipi,
          iletisimAdresIl: body.iletisimAdresIl,
          iletisimAdresIlce: body.iletisimAdresIlce,
          iletisimAdresMahalle: body.iletisimAdresMahalle,
          iletisimAdres: body.iletisimAdres,
          ekstreGonderimTercihi: body.ekstreGonderimTercihi,
          email: body.email,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/Apply8",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply9: builder.mutation<BaseResponse, Apply9Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          sube: body.sube,
          vadesizHesapOnay: body.vadesizHesapOnay,
          hesapCuzdanOnay: body.hesapCuzdanOnay,
          secilenTeklifler: body.secilenTeklifler,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPos/Apply9",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
  })
})

export const { useGetTokenByTckn1Mutation, useGetConfigListMutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation, useApply3Mutation, usePosGetGiroScaleDetailMutation, useApply4Mutation, useApply5Mutation, usePosOkcMarkaListMutation, useOkcMaliIdMutation, useOkcModelListMutation, useApply6Mutation, useGetSecondNationalyCountryListMutation, useGetWorkTypesMutation, useGetVarlikKaynagiMutation, useGetIslemHacimleriMutation, useGetIslemSayisiMutation, useApply7Mutation, useGetWorkPlaceNameByNameMutation, useGetCitiesMutation, useGetTownsMutation, useGetDistrictsMutation, useApply8Mutation, useApply9Mutation } = api

export default api
